import type React from 'react'

export function FadeUp({
  children
}: {
  children: React.ReactNode
  delay?: number
  duration?: number
}) {
  // Keep marketing content present in the server HTML and immediately paintable.
  // A decorative entrance animation is not worth shipping Framer Motion to every
  // public page or risking an opacity:0 LCP element before hydration.
  return <div>{children}</div>
}
